import { useDisclosuresListPage } from './useDisclosuresListPage';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { Container } from '@components/ions/layouts';
import { List } from '@components/organisms/List/List';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import IconDisclosuresEmpty from '@shared/svgs/IconDisclosuresEmpty.svg';

import {
    HeaderWrapper,
    SearchField,
    Title,
} from './DisclosuresListPage.styled';

export const DisclosuresListPage = () => {
    const {
        columns,
        disclosureList,
        field,
        loading,
        onReset,
        onSearch,
        openDisclosureDetails,
        pagination,
        searchValue,
        t,
    } = useDisclosuresListPage();

    return (
        <DefaultLayout contentPadding={{ bottom: 40 }}>
            <Container>
                <ContainerInner>
                    <ContainerSection>
                        <HeaderWrapper>
                            <Title>{t('MY_FORMS_TEXT')}</Title>
                            <SearchField
                                {...field}
                                onReset={onReset}
                                onSearch={onSearch}
                                placeholder={t('SEARCH_PLACEHOLDER')}
                                testId="ydwCc4X"
                            />
                        </HeaderWrapper>
                        <List
                            columns={columns}
                            emptyListProps={{
                                description: t('NO_ACTIVE_DISCLOSURES_INFO'),
                                icon: IconDisclosuresEmpty,
                                title: t('NO_ACTIVE_DISCLOSURES'),
                            }}
                            isLoading={loading}
                            isSearch={!!searchValue}
                            list={disclosureList}
                            onRowClick={openDisclosureDetails}
                            pagination={pagination}
                            testId="7kQp8D_"
                        />
                    </ContainerSection>
                </ContainerInner>
            </Container>
        </DefaultLayout>
    );
};
